export class LanguageBaseView {
    id: number;
    code: string;

    constructor(data?: any) {
        this.id = data?.id ?? 2;
        this.code = data?.code ?? "Language.code.nl";
    }

    getShortCode(): string {
        return this.code.replace("Language.code.", "");
    }

}